import { render, staticRenderFns } from "./comp_PayU-CheckoutConfirmButton.vue?vue&type=template&id=3fd1565c&scoped=true&"
import script from "./comp_PayU-CheckoutConfirmButton.vue?vue&type=script&lang=js&"
export * from "./comp_PayU-CheckoutConfirmButton.vue?vue&type=script&lang=js&"
import style0 from "./comp_PayU-CheckoutConfirmButton.vue?vue&type=style&index=0&id=3fd1565c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd1565c",
  null
  
)

export default component.exports